import { render, staticRenderFns } from "./ContractSignRole.vue?vue&type=template&id=1bb6ff90&scoped=true&"
import script from "./ContractSignRole.vue?vue&type=script&lang=js&"
export * from "./ContractSignRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb6ff90",
  null
  
)

export default component.exports